<script>
import { Inertia } from '@inertiajs/inertia'
import Edit from './edit.vue'

export default {
  extends: Edit,

  data() {
    return {
      ...Edit.data.call(this),
      title: 'Roles :: Add Role',
    }
  },

  methods: {
    submit() {
      Inertia.post(this.$route('roles.store'), this.form, {
        onFinish: () => {
          this.$refs.topAnchor.scrollIntoView()
        }
      })
    },
  }
}
</script>
